import { render } from "./EditContactInfoAndHelp.vue?vue&type=template&id=38c58813"
import script from "./EditContactInfoAndHelp.vue?vue&type=script&lang=js"
export * from "./EditContactInfoAndHelp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__